import { CityViewModel } from '@common/model/location/cityViewModel';
import { LinkingCitiesListRequest } from '@common/model/location/linkingCitiesListRequest';
import { LinkingCitiesListCoreServerResponse } from '@common/model/location/linkingCitiesListCoreServerResponse';
import { coreLocationApi } from './location';
import { CoreLocationApiTags } from './tags';

export const coreLocationLinkingCitiesListApi = coreLocationApi.injectEndpoints({
  endpoints: (builder) => ({
    getMainLinkingCitiesList: builder.query<CityViewModel[], LinkingCitiesListRequest>({
      query: ({ cityId, ...params }) => ({
        url: `location/cities/${cityId}/linking`,
        params,
      }),
      transformResponse: (response: LinkingCitiesListCoreServerResponse, _meta, _request) => {
        return response.data;
      },
      providesTags: (_result, _error, { cityId }) => [{ type: CoreLocationApiTags.MainLinkingCitiesList, id: cityId }],
    }),
  }),

  overrideExisting: false,
});
